module.exports = __webpack_public_path__ + "img/mission-image-2.bee4ed23.jpeg";